import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export class MixedContentService extends BaseService {
    async getMixedContentJsonFile<T = any>(filePath: string): Promise<T> {
        const response = await this.ngCall<T>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.landingPage.bucketName,
                    filePath,
                },
            },
        );
        return response.data;
    }
}
